import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from "@angular/core";

import { Observable, of } from 'rxjs';

import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { ReponseBase } from './reponse-base';
import { ReparationEntite } from '../entites/reparation';

@Injectable({ providedIn: 'root' })
export class ReparationService {

  private obtenirListeUrl = environment.apiBaseUrl + 'reparation';
  private obtenirListeHistoriqueUrl = environment.apiBaseUrl + 'reparation/historique';
  private obtenirListeParItemUrl = environment.apiBaseUrl + 'reparation/item/{id}';
  private obtenirUrl = environment.apiBaseUrl + 'reparation/{id}';
  private ajouterUrl = environment.apiBaseUrl + 'reparation';
  private modifierUrl = environment.apiBaseUrl + 'reparation/modifier';
  private supprimerUrl = environment.apiBaseUrl + 'reparation/{id}';


  public httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  constructor(
    private http: HttpClient,
    public router: Router) { }


  public ObtenirListe(): Promise<ReponseBase<ReparationEntite[]>> {
    var p = this.http.get<ReponseBase<ReparationEntite[]>>(this.obtenirListeUrl)
      .toPromise();

      p.catch(() => this.router.navigateByUrl('error'));

      return p;
  }

  public ObtenirListeHistorique(): Promise<ReponseBase<ReparationEntite[]>> {
    var p = this.http.get<ReponseBase<ReparationEntite[]>>(this.obtenirListeHistoriqueUrl)
      .toPromise();

      p.catch(() => this.router.navigateByUrl('error'));

      return p;
  }

  public ObtenirListeParItem(id: number): Promise<ReponseBase<ReparationEntite[]>> {
    var p = this.http.get<ReponseBase<ReparationEntite[]>>(this.obtenirListeParItemUrl.replace('{id}', id.toString()))
      .toPromise();

      p.catch(() => this.router.navigateByUrl('error'));

      return p;
  }

  public Obtenir(id: number): Promise<ReponseBase<ReparationEntite>> {
    var p = this.http.get<ReponseBase<ReparationEntite>>(this.obtenirUrl.replace('{id}', id.toString()))
      .toPromise();

      p.catch(() => this.router.navigateByUrl('error'));

      return p;
  }

  public Ajouter(reparation: ReparationEntite): Promise<ReponseBase<ReparationEntite>> {
    var p = this.http.post<ReponseBase<ReparationEntite>>(this.ajouterUrl, JSON.stringify(reparation), this.httpOptions)
      .toPromise();

      p.catch(() => this.router.navigateByUrl('error'));

      

      return p;
  }

  public Modifier(reparation: ReparationEntite): Promise<ReponseBase<ReparationEntite>> {
    var p = this.http.post<ReponseBase<ReparationEntite>>(this.modifierUrl, JSON.stringify(reparation), this.httpOptions)
      .toPromise();

      p.catch(() => this.router.navigateByUrl('error'));

      

      return p;
  }

  public Supprimer(id: number): Promise<ReponseBase<number>> {
    var p = this.http.delete<ReponseBase<number>>(this.supprimerUrl.replace('{id}', id.toString()))
      .toPromise();

      p.catch(() => this.router.navigateByUrl('error'));

      

      return p;
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);

      this.log(`${operation} failed: ${error.message}`);

      this.router.navigateByUrl('erreurtechnique');

      return of(result as T);
    };
  }

  private log(message: string) {
    console.log(message);
  }
}
